export default function ({ store, redirect, route, error }) {
  // Skip middleware for 404 page and error pages
  // Check if route is not found (404) - route.matched will be empty for invalid routes
  if (!route.matched || route.matched.length === 0) {
    // Route doesn't exist, show 404
    return error({ statusCode: 404, message: 'Halaman tidak ditemukan' })
  }

  // Skip for known error/404 routes and catch-all route
  // In Nuxt, catch-all route name starts with 'all' or contains 'all-'
  const routeName = route.name || ''
  if (
    routeName === '404' ||
    routeName.startsWith('all') ||
    route.path === '/404' ||
    route.path.includes('error') ||
    route.path === '/_'
  ) {
    return
  }

  // For admin routes, require valid token
  if (route.path.startsWith('/admin')) {
    // Get token from store
    const token = store.state.auth.strategy?.token?.get()
    const loggedIn = store.state.auth.loggedIn

    // Must have token AND be logged in
    // Note: user data might not be loaded yet on first login, so we only check token and loggedIn
    if (!token || !loggedIn) {
      // Only clear auth state if loggedIn is true but token is missing (inconsistent state)
      if (loggedIn && !token) {
        // Inconsistent state - try to logout
        try {
          store.dispatch('auth/logout')
        } catch (e) {
          // Ignore logout errors
        }
      }
      return redirect('/auth/login')
    }
  }

  // If user is logged in but trying to access login page, redirect to home
  if (store.state.auth.loggedIn && route.path === '/auth/login') {
    const token = store.state.auth.strategy?.token?.get()
    if (token) {
      return redirect('/admin/home')
    }
  }
}
